import { Observable } from "rxjs";
import {
  AgendaItem,
  CreateWorkloadDto,
  CreateWorkloadResponse,
} from "../../data/repositories/agenda/entities/agenda.model";
import { UserRoleDTO } from "../use-cases/agenda/get-role.usecase";

export abstract class AgendaRepository {
  abstract retrieveAgenda(rinaId: string): Observable<AgendaItem[]>;
  abstract retrieveWorkspace(rinaId: string): Observable<AgendaItem[]>;
  abstract sendNotification(id: number): Observable<AgendaItem>;
  abstract createWorkloadDraft(
    workload: CreateWorkloadDto,
  ): Observable<CreateWorkloadResponse>;
  abstract getUserRole(rinaId: string): Observable<UserRoleDTO>;
}
